import { render, staticRenderFns } from "./Footer4.vue?vue&type=template&id=7b323320&scoped=true&"
import script from "./Footer4.vue?vue&type=script&lang=js&"
export * from "./Footer4.vue?vue&type=script&lang=js&"
import style0 from "./Footer4.vue?vue&type=style&index=0&id=7b323320&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b323320",
  null
  
)

export default component.exports